






import { Component, Vue } from 'vue-property-decorator'
import { Validate } from 'vuelidate-property-decorators'
import { minValue, maxValue } from 'vuelidate/lib/validators'

@Component
export default class MonerisPaymentPlans extends Vue {}
